// extracted by mini-css-extract-plugin
export var icon = "_5e-1";
export var subtext = "_5e-0";